<template>
    <div class="cooperate-remind">
        <div class="content-header">

            <el-row :gutter="20" class="list-wrap_remind">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12"   :span="12" v-for="(item,index1) in bankList" :key="index1" style="margin-bottom: 10px;">
                    <el-card class="box-card">
                        <div slot="header" class="header-title">
                            <span>{{item.name}}</span>
                            <el-link :href="item.url" type="primary" style="float: right; padding: 3px 0"  :underline="false">去写我的{{item.questionClassName}}</el-link>
                        </div>

                            <el-table :data="item.list" stripe border center :size="GCONFIG.styleTableSize" >
                                <el-table-column type="index" label="序号" ></el-table-column>
                                <el-table-column label="姓名" prop="userName"  ></el-table-column>
                                <el-table-column label="期间" prop="periodName" ></el-table-column>

                                <el-table-column label="操作" fixed="right" >
                                    <template slot-scope="scope">
                                        <el-link v-if="scope.row.questionClassId==14" href="//erpnew.lechun.cc/admin_sys_performance_other.html" type="primary"  :underline="false">去处理</el-link>
                                        <el-button v-if="scope.row.questionClassId!=14" :type="scope.row.isLeader==0||scope.row.isLeader==2?'warning':'success'" size="mini" @click="getCooperativeQues(scope.row)">去处理</el-button>
                                    </template>
                                </el-table-column>

                            </el-table>


                    </el-card>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"  :span="24" style="margin-bottom: 10px;">
                    <el-card class="box-card" style="height: 430px">
                        周笔记榜单:<cooperateBank :sectionClassId="3"></cooperateBank>
                    </el-card>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12"  :span="12" style="margin-bottom: 10px;">
                    <el-card class="box-card">
                        感谢我:<cooperateThanks :sectionClassId="3"></cooperateThanks>
                    </el-card>
                </el-col>

                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12"  :span="12" style="margin-bottom: 10px;">
                    <el-card class="box-card">
                        需要我帮助:<cooperateCall :sectionClassId="3"></cooperateCall>
                    </el-card>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12"  :span="12" style="margin-bottom: 10px;">
                    <el-card class="box-card">
                        回复我:<cooperateCallback :sectionClassId="3"></cooperateCallback>
                    </el-card>
                </el-col>
            </el-row>

        </div>

        <el-drawer
                :title="title"
                :visible.sync="drawerShow"
                direction="rtl"

                :before-close="handleClose" :size="questionType==10?'90%':'70%'" style="margin-bottom:0px;">
            <template v-if="questionType==10">
                <quarter :param="paper" v-if="reFresh"></quarter>
            </template>
            <template v-else>
                <cooperative :param="paper" v-if="reFresh"></cooperative>
            </template>

        </el-drawer>
    </div>
</template>

<script>
    import cooperative from '@/components/cooperative/cooperative'
    import quarter from "@/components/cooperative/quarter";
    import cooperateCall from '@/components/cooperative/cooperativeCall'
    import cooperateCallback from '@/components/cooperative/cooperativeCallback'
    import cooperateBank from '@/components/cooperative/cooperativeBank'
    import cooperateThanks from '@/components/cooperative/cooperativeThanks'

    //定义组件
    export default {
        data() {
            return {
                bankList:[],
                drawerShow:false,
                paper:{},
                title:"",
                reFresh:true,
                questionType:0,

            }
        },
        computed:{

        },
        props:['sectionClassId'],
        //挂载时候执行
        mounted() {

            this.getSubordinateUnConfirmReport()
        },
        watch:{
            title(){

                this.reFresh= false
                this.$nextTick(()=>{

                    this.reFresh = true
                })
            }
        },
        methods: {
            getSubordinateUnConfirmReport() {
                this.$store.dispatch('getSubordinateUnConfirmReport',{}).then(res=>{
                    this.bankList = res
                })
            },
            getCooperativeQues(row){
                this.questionType=row.questionClassId;
                this.$store.dispatch('getPaperPage',{paperId:row.id,classId:row.questionClassId,periodId:row.periodId}).then(res=>{

                    this.paper=res;
                    this.title=res.questionClassName+" (标*必填)"+" :【"+res.userName+"】"+res.periodName;
                    this.drawerShow=true;
                })

            },
            handleClose(done){

                done();
            },

        },
        components:{
            cooperative,quarter,cooperateCall,cooperateCallback,cooperateBank,cooperateThanks

        }
    }
</script>
<style lang="scss" rel="stylesheet/scss" scoped >
    .el-card__body{
        overflow-y: scroll;
        height: 440px;
        padding:10px;
    }
    .el-card__header{
        padding:10px 10px;
    }
    .cooperate-remind{
        .list-wrap{
            margin: 10px;
            text-align: left;
        }
        .box-card{
            height: 490px;
            .text-item{
               margin-bottom: 10px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/cooperative/confirmremind.vue